module.exports = require("lodash/isFunction");


//////////////////
// WEBPACK FOOTER
// external "lodash/isFunction"
// module id = 2
// module chunks = 0